<template>
  <pt-business-order-lot-form ref="form" class="pt-business-order-lot-form__withData">
    <div :class="$style.btns">
      <el-button type="primary" v-intervalclick="{func:createLot,time:500}">立即创建</el-button>
			<el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </pt-business-order-lot-form>
</template>

<script>
import PtBusinessOrderLotForm from './index'
export default {
  name: 'pt-business-order-lot-form__withData',
  components: {
    'pt-business-order-lot-form': PtBusinessOrderLotForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    createLot () {
      this.form.validate().then(formValue => {
        this.form.submit()
      })
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style module lang="less">
.btns{
  margin-top:20px;
}
</style>
